import { render } from "./ImageInput.vue?vue&type=template&id=8bdd9d3a"
import script from "./ImageInput.vue?vue&type=script&lang=js"
export * from "./ImageInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__